module.exports = __webpack_public_path__ + "static/img/nav9.483f915b.svg";